import { useState } from "react";
import { Typography, Button, Form, Input, Alert, Checkbox } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { LockOutlined, UserOutlined, MailOutlined } from "@ant-design/icons";
import { request } from "../../axios_helper.js";
import { LegalDocumentLinks, LegalDocumentModal } from "../legal/LegalDocuments.js";
import { NAME_MAX_LENGTH, usernameRules } from "../../util/nameRules.js";

const { Title } = Typography;

export default function Register({ embedded = false, initialCredentials, onCredentialsChange }) {
  const navigate = useNavigate();
  const [errorText, setErrorText] = useState(null);
  const [registering, setRegistering] = useState(false);
  const [openLegalDocument, setOpenLegalDocument] = useState(null);

  const onFinish = (values) => {
    setErrorText(null);
    setRegistering(true);
    request("POST", "/api/v1/auth/register", false, {
      username: values.username,
      email: values.email,
      password: values.password,
      acceptedTerms: values.acceptedTerms,
    }).then((response) => {
      if (response?.status === 202) {
        navigate("/home/verify-email-pending", { state: { username: values.username, email: values.email } });
      } else {
        setErrorText(response?.data?.message ?? "Create account failed");
      }
    }).finally(() => setRegistering(false));
  };

  return (
    <div style={{ margin: "auto", width: embedded ? "100%" : "200px" }}>
      {!embedded && <Title style={{ textAlign: "center" }}>Register</Title>}
      <Form name="register" initialValues={{ remember: true, username: initialCredentials?.username, password: initialCredentials?.password }}
        onValuesChange={(_, values) => onCredentialsChange?.({ username: values.username, password: values.password })} style={{ margin: "auto" }} onFinish={onFinish}>
        {errorText !== null && <Alert style={{ marginBottom: "10px" }} message={errorText.length > 0 ? errorText : "Create account failed"} type="error" showIcon />}
        <Form.Item name="username" rules={usernameRules}>
          <Input prefix={<UserOutlined />} placeholder="Username" maxLength={NAME_MAX_LENGTH} />
        </Form.Item>
        <Form.Item name="email" rules={[{ required: true, message: "Please input an Email" }]}>
          <Input prefix={<MailOutlined />} placeholder="Email" />
        </Form.Item>
        <Form.Item name="password" rules={[{ required: true, message: "Please input a Password" }]}>
          <Input prefix={<LockOutlined />} type="password" placeholder="Password" />
        </Form.Item>

        <Form.Item name="acceptedTerms" valuePropName="checked" rules={[{ validator: (_, accepted) => accepted ? Promise.resolve() : Promise.reject(new Error("You must accept the Terms of Service")) }]}>
          <Checkbox>I accept the <LegalDocumentLinks onOpen={setOpenLegalDocument} /></Checkbox>
        </Form.Item>

        <Form.Item>
          <Button block type="primary" htmlType="submit" loading={registering}>
            Create Account
          </Button>
          {embedded ? <Link className="landing-auth-secondary" to="/">Back to sign in</Link> : <>or <Link to="/home/login">Sign in</Link></>}
        </Form.Item>
      </Form>
      <LegalDocumentModal document={openLegalDocument} open={openLegalDocument !== null} onClose={() => setOpenLegalDocument(null)} />
    </div>
  );
}
